<template>
  <div class="comissao">
      <h1 class="titulo ml-12 mt-8">Comissão</h1>
      <div class="integrante">
          <img src="../assets/comissao/foto_1.png" alt="">
          <p>Sartori</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_2.png" alt="">
          <p>Vitão</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_3.png" alt="">
          <p>Dimitri</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_4.png" alt="">
          <p>Dj Luis Ricardo</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_5.png" alt="">
          <p>Marcello Maia</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_6.png" alt="">
          <p>Thais</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_7.png" alt="">
          <p>Glau</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_8.png" alt="">
          <p>Dilinho</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_9.png" alt="">
          <p>Gabi Pereira</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_10.png" alt="">
          <p>Ju Tauane</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_11.png" alt="">
          <p>Pontirolli</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_12.png" alt="">
          <p>Leticia</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_13.png" alt="">
          <p>Maria Eduarda</p>
      </div>
      <div class="integrante">
          <img src="../assets/comissao/foto_14.png" alt="">
          <p>Fe Escobar</p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'comissao',
}
</script>


<style scoped lang="scss">
.comissao{
    background: #f07938;
    width: 1450px;
    height: 1080px;
    overflow: auto;
    padding: 20px;
    .titulo {
        font-size: 46px;
        text-transform: uppercase;
        color: white;
    }
    .integrante {
        width: 290px;
        height: 290px;
        border-radius: 50%;
        position: relative;
        float: left;
        margin: 70px 50px;
        box-shadow: 1px 0px 0px 15px #FFF, -10px 10px 0px 15px #c75d23;
        img {
            width: 100%;
            border-radius: 50%;
        }
        p{
            position: absolute;
    bottom: 262px;
    font-size: 36px;
    font-weight: 900;
    width: max-content;
    color: #000000;
    text-align: center;
    transform: rotate(-10deg);
    left: -25px;
    /* text-shadow: -3px 3px 0px #f07938; */
    background: #fff;
    padding: 0px 15px;
    border-radius: 10px;
    box-shadow: -7px 7px 0px 0px #c75d23;
        }
    }
}
</style>